module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-menu', _vm._b({
    staticClass: "ci-sidebar",
    attrs: {
      "mode": "vertical"
    },
    on: {
      "select": _vm.select,
      "open": _vm.open,
      "close": _vm.close
    }
  }, 'el-menu', _vm.$props), [_c('div', {
    staticClass: "ci-sidebar__content"
  }, [(_vm.titlename) ? _c('el-menu-item', {
    staticClass: "ci-sidebar__title",
    attrs: {
      "index": "1"
    }
  }, [_vm._v(_vm._s(_vm.titlename))]) : _vm._e(), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.handleSidebar
    }
  }, [_c('i', {
    staticClass: "ci-sidebar__affix"
  })]), _vm._v(" "), _vm._l((_vm.data), function(item, index) {
    return (_vm.data) ? [(item.items) ? _c('el-submenu', {
      attrs: {
        "index": _vm.getIndex(index)
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: item.icon
    }), _vm._v(_vm._s(item.title))]), _vm._v(" "), _vm._l((item.items), function(menuItem, menuIndex) {
      return [(menuItem.items) ? _c('el-menu-item-group', {
        attrs: {
          "title": menuItem.title
        }
      }, _vm._l((menuItem.items), function(subItem, subIndex) {
        return _c('a', {
          key: subIndex,
          on: {
            "click": function($event) {
              _vm.startRouter(subIndex)
            }
          }
        }, [_c('el-menu-item', {
          attrs: {
            "index": _vm.getIndex(subIndex, index)
          }
        }, [_c('i', {
          class: subItem.icon
        }), _vm._v("\n                  " + _vm._s(subItem.title) + "\n              ")])], 1)
      })) : _c('a', {
        on: {
          "click": function($event) {
            _vm.startRouter(menuItem)
          }
        }
      }, [_c('el-menu-item', {
        attrs: {
          "index": _vm.getIndex(menuIndex, index)
        }
      }, [_c('i', {
        class: menuItem.icon
      }), _vm._v("\n                " + _vm._s(menuItem.title) + "\n              ")])], 1)]
    })], 2) : _c('a', {
      on: {
        "click": function($event) {
          _vm.startRouter(item)
        }
      }
    }, [_c('el-menu-item', {
      attrs: {
        "index": _vm.getIndex(index)
      }
    }, [_c('i', {
      class: item.icon
    }), _vm._v("\n            " + _vm._s(item.title) + "\n          ")])], 1)] : _vm._e()
  })], 2), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-563e05cb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/ci-components/components/sidebar.vue
// module id = 255
// module chunks = 4